// src/pages/home_component/Questions.js
import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2"; // 👈 install: npm install sweetalert2

const API_BASE = "https://doshfebackend.teemah.com.ng";

const Questions = () => {
  const { studentId } = useParams();
  const navigate = useNavigate();

  const [student, setStudent] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [attemptId, setAttemptId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [timeLeft, setTimeLeft] = useState(0); // seconds
  const [answers, setAnswers] = useState({});

  // prevent double submit (manual + auto)
  const submittingRef = useRef(false);

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const questionsPerPage = 5;

  // helpers
  const makeImgUrl = (path) =>
    !path ? null : path.startsWith("http") ? path : `${API_BASE}${path}`;

  useEffect(() => {
    const fetchStudent = async () => {
      const res = await fetch(`${API_BASE}/api/assessments/students/${studentId}/`);
      if (!res.ok) throw new Error("Failed to fetch student info");
      setStudent(await res.json());
    };

    const fetchQuestions = async () => {
      try {
        const res = await fetch(
          `${API_BASE}/api/assessments/splitted/${studentId}/questions/`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({}),
          }
        );

        if (res.status === 409) {
          const d = await res.json();
          alert("This attempt is already submitted. Score: " + d.total_score);
          return;
        }

        if (!res.ok) throw new Error("Failed to fetch questions");

        const data = await res.json();
        setAttemptId(data.attempt_id);

        const formatted = data.questions.map((q) => ({
          id: q.id,
          question_text: q.question_text,
          question_image: makeImgUrl(q.question_image),
          options: [
            { key: "A", text: q.option_a },
            { key: "B", text: q.option_b },
            { key: "C", text: q.option_c },
            { key: "D", text: q.option_d },
          ],
          correct_option: q.correct_option,
        }));

        setQuestions(formatted);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false); // ensure spinner stops
      }
    };

    if (studentId) {
      fetchStudent().catch((e) => setError(e.message));
      fetchQuestions().catch((e) => setError(e.message));
    }
  }, [studentId]);

  // countdown (starts when attempt is ready)
  useEffect(() => {
  if (!attemptId) return;

  const savedEndTime = localStorage.getItem(`attempt_${attemptId}_endtime`);
  let endTime;

  if (savedEndTime) {
    endTime = parseInt(savedEndTime, 10);
  } else {
    endTime = Date.now() + 30 * 60 * 1000; // 30 mins from now
    localStorage.setItem(`attempt_${attemptId}_endtime`, endTime);
  }

  const interval = setInterval(() => {
    const diff = Math.floor((endTime - Date.now()) / 1000);
    if (diff <= 0) {
      clearInterval(interval);
      if (!submittingRef.current) {
        submittingRef.current = true;
        handleSubmit(true);
      }
      setTimeLeft(0);
    } else {
      setTimeLeft(diff);
    }
  }, 1000);

  return () => clearInterval(interval);
}, [attemptId]);

  const handleAnswer = (questionId, optionKey) => {
    setAnswers((prev) => ({
      ...prev,
      [questionId]: optionKey,
    }));
  };



//   const handleSubmit = async (auto = false) => {
//   if (!attemptId || submittingRef.current) return;

//   try {
//     submittingRef.current = true;

//     const answersWithStringKeys = Object.fromEntries(
//       Object.entries(answers).map(([k, v]) => [String(k), v])
//     );

//     const payload = { answers: answersWithStringKeys };

//     const res = await fetch(`${API_BASE}/api/assessments/attempts/${attemptId}/submit/`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(payload),
//     });

//     const data = await res.json();

//     if (!res.ok) {
//       throw new Error(data?.error || "Failed to submit test");
//     }

//     // Instead of alert, navigate to results page
//     navigate(`/result/${attemptId}`, { state: { result: data } });

//   } catch (err) {
//     submittingRef.current = false;
//     alert("Error submitting test: " + err.message);
//   }
// };
  
  

// ...

// countdown (persist across reloads)

const handleSubmit = async (auto = false) => {
  if (!attemptId || submittingRef.current) return;

  try {
    submittingRef.current = true;

    const answersWithStringKeys = Object.fromEntries(
      Object.entries(answers).map(([k, v]) => [String(k), v])
    );

    const payload = { answers: answersWithStringKeys };

    const res = await fetch(`${API_BASE}/api/assessments/attempts/${attemptId}/submit/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data?.error || "Failed to submit test");
    }

    if (auto) {
      await Swal.fire({
        icon: "info",
        title: "⏰ Time’s up!",
        text: `Your test has been auto-submitted.`,
        confirmButtonText: "View Result",
      });
    }

    navigate(`/result/${attemptId}`, { state: { result: data } });
  } catch (err) {
    submittingRef.current = false;
    Swal.fire({
      icon: "error",
      title: "Submission Error",
      text: err.message,
    });
  }
};

// useEffect(() => {
//   if (!attemptId) return;

//   const savedEndTime = localStorage.getItem(`attempt_${attemptId}_endtime`);
//   let endTime;

//   if (savedEndTime) {
//     endTime = parseInt(savedEndTime, 10);
//   } else {
//     endTime = Date.now() + 30 * 60 * 1000; // 30 mins from now
//     localStorage.setItem(`attempt_${attemptId}_endtime`, endTime);
//   }

//   const interval = setInterval(() => {
//     const diff = Math.floor((endTime - Date.now()) / 1000);
//     if (diff <= 0) {
//       clearInterval(interval);
//       if (!submittingRef.current) {
//         submittingRef.current = true;
//         handleSubmit(true);
//       }
//       setTimeLeft(0);
//     } else {
//       setTimeLeft(diff);
//     }
//   }, 1000);

//   return () => clearInterval(interval);
// }, [attemptId]);


// ✅ New handleManualSubmit (uses sweetalert2)

// ✅ Timer persistence + auto submit
useEffect(() => {
  if (!attemptId) return;

  // --- restore answers if already saved
  const savedAnswers = localStorage.getItem(`attempt_${attemptId}_answers`);
  if (savedAnswers) {
    setAnswers(JSON.parse(savedAnswers));
  }

  // --- restore or create end time
  const savedEndTime = localStorage.getItem(`attempt_${attemptId}_endtime`);
  let endTime;

  if (savedEndTime) {
    endTime = parseInt(savedEndTime, 10);
  } else {
    endTime = Date.now() + 30 * 60 * 1000; // 30 minutes from now
    localStorage.setItem(`attempt_${attemptId}_endtime`, endTime);
  }

  // --- countdown interval
  const interval = setInterval(() => {
    const diff = Math.floor((endTime - Date.now()) / 1000);

    if (diff <= 0) {
      clearInterval(interval);
      if (!submittingRef.current) {
        submittingRef.current = true;
        handleSubmit(true); // ⏰ auto submit with SweetAlert
      }
      setTimeLeft(0);
    } else {
      setTimeLeft(diff);
    }
  }, 1000);

  return () => clearInterval(interval);
}, [attemptId]);

// ✅ Save answers anytime they change
useEffect(() => {
  if (attemptId) {
    localStorage.setItem(
      `attempt_${attemptId}_answers`,
      JSON.stringify(answers)
    );
  }
}, [answers, attemptId]);

const handleManualSubmit = () => {
  const unanswered = questions
    .filter((q) => !answers[q.id])
    .map((q, i) => i + 1); // question numbers

  if (unanswered.length > 0) {
    Swal.fire({
      icon: "warning",
      title: "Unanswered Questions",
      text: `You are yet to answer: ${unanswered.join(", ")}`,
      confirmButtonText: "OK",
      
      confirmButtonColor: "#3085d6", // ✅ blue button
    });
    return;
  }

  Swal.fire({
    title: "Submit Answers?",
    text: "Do you want to submit now or cross-check again?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes, Submit",
    cancelButtonText: "Cross-check",
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#dd5f34",
    
    confirmButtonColor: "#3085d6", // ✅ blue button
  }).then((result) => {
    if (result.isConfirmed) {
      handleSubmit(false);
    }
  });
};
  // scroll to top when page changes
useEffect(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
}, [currentPage]);




  if (loading) return <p className="text-center">Loading...</p>;
  if (error) return <p className="text-red-500 text-center">{error}</p>;

  // pagination logic
  const indexOfLastQ = currentPage * questionsPerPage;
  const indexOfFirstQ = indexOfLastQ - questionsPerPage;
  const currentQuestions = questions.slice(indexOfFirstQ, indexOfLastQ);
  const totalPages = Math.max(1, Math.ceil(questions.length / questionsPerPage));

  return (
    <div className="p-6 max-w-4xl mx-auto mt-28 bg-white">
      {/* ✅ Student info (UI unchanged) */}
      {student && (
  <div className="mb-6 p-6 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-2xl shadow-lg">
    {/* Header with Logo + Title + Timer */}
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4 space-y-4 sm:space-y-0">
      {/* Logo + Title */}
      <div className="flex items-center space-x-4">
        <img 
          src="/dca.png" 
          alt="Logo" 
          className="h-14 w-auto rounded-lg shadow-md border"
        />
        <h2 className="text-xl sm:text-2xl font-bold tracking-wide">
          Student Information
        </h2>
      </div>

      {/* Timer Badge */}
      <div className="bg-red-600 px-4 py-2 rounded-xl shadow-md text-lg font-semibold text-center">
        ⏳ {Math.floor(timeLeft / 60)}:
        {(timeLeft % 60).toString().padStart(2, "0")}
      </div>
    </div>

    {/* Student Details */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm md:text-base">
      <p className="bg-white/10 p-3 rounded-lg">
        <strong>Name:</strong> {student.student_name}
      </p>
      <p className="bg-white/10 p-3 rounded-lg">
        <strong>Age:</strong> {student.age}
      </p>
      <p className="bg-white/10 p-3 rounded-lg">
        <strong>Class:</strong> {student.class_student}
      </p>
    </div>
  </div>
)}



      {/* ✅ Questions (UI unchanged) */}
      <div className="space-y-6">
        {currentQuestions.map((q, index) => (
          <div
            key={q.id}
            className="p-4 border rounded-lg shadow hover:shadow-md transition bg-blue-100"
          >
            <div className="font-semibold">
              {indexOfFirstQ + index + 1}.{" "}
              {q.question_text ? (
                <span>{q.question_text}</span>
              ) : q.question_image ? (
                <img
                  src={`${q.question_image}`}
                  alt={`Question ${indexOfFirstQ + index + 1}`}
                  className="max-w-full h-auto rounded"
                />
              ) : null}
            </div>

            <ul className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-3">
  {q.options.map((opt) => (
    <li
      key={opt.key}
      className={`p-3 border border-gray-300 rounded-lg cursor-pointer transition 
        ${
          answers[q.id] === opt.key
            ? "bg-blue-200 border-blue-500 shadow-md"
            : "hover:bg-gray-100"
        }`}
      onClick={() => handleAnswer(q.id, opt.key)}
    >
      {/* 👇 If the question has an image, just show option text */}
      {q.question_image ? opt.text : `${opt.key}. ${opt.text}`}
    </li>
  ))}
</ul>

          </div>
        ))}
      </div>

      {/* ✅ Pagination controls (UI unchanged) */}
      <div className="flex justify-center items-center mt-6 space-x-4">
        <button
          className="px-4 py-2 bg-gray-300 rounded disabled:opacity-50"
          onClick={() => setCurrentPage((p) => p - 1)}
          disabled={currentPage === 1}
        >
          Prev
        </button>
        <span>
          Page {currentPage} of {totalPages}
        </span>
        <button
          className="px-4 py-2 bg-gray-300 rounded disabled:opacity-50"
          onClick={() => setCurrentPage((p) => p + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>

      {/* ✅ Submit button (UI unchanged) */}
      {/* ✅ Submit button only on last page */}
{currentPage === totalPages && (
  <div className="flex justify-center mt-8">
    <button
      onClick={handleManualSubmit}
      className="px-6 py-3 bg-green-600 text-white rounded-lg shadow hover:bg-green-700"
    >
      Submit Answers
    </button>
  </div>
)}

      </div>

  );
};

export default Questions;
